export enum AuthType {
    None,
    Basic,
    Token,
};

export const Colors = {
    lightBlue: "#6995d7",
    darkBlue: "blue",
    darkTan: "#E1CCAE",            // Footer BG
    lightTan: "#edd9ab",           // login form
    mediumBrown: "#a14e16",        // login button
    lightBrown: "#80441d",         // links
    gold: "#cabf5c",
    white: "#FFFFFF",
    black: "#000000",
    red: "#C53131",
    darkRed: "#7a1f1f",
    orange: "#EB5118",

    // Border colors
    borderGoldPrimary: "rgba(202, 171, 92, 0.95)",
    borderGoldSecondary: "#cabf5c",
    borderParchmentPrimary: "rgba(45, 36, 27, .18)",
    borderParchmentSecondary: "rgba(68, 45, 14, 0.664)",
    borderSelectedPrimary: "rgba(90, 174, 182, .95)",
    borderSelectedSecondary: "rgba(90, 174, 182, .30)",
    borderSelectedTertiary: "rgba(90, 174, 182, .18)",

    // Status colors
    statusDown: "#C53131",          // red
    statusDead: "#2b2b2b",
    statusPoisoned: "#279727ff",
    statusMagic: "#3b5fa8",

    // Core UI Colors
    uiTextPrimary: "#f5f1e6",                      // Off-white for dark backgrounds
    uiTextSecondary: "rgba(245,241,230,0.75)",
    uiTextMuted: "rgba(245,241,230,0.55)",
    uiBorderPrimary: "rgba(202, 171, 92, 0.95)",   // Gold border

    // Header colors
    headerTop: "#102b42",
    headerBottom: "#0b1a2a",
    headerText: "#d8c29b",
    headerLink: "#e6d4b1",
    headerBarEnd: "#a79372",                       // Header bottom bar ends
    headerBarCenter: "#cbb793",                    // Header bottom bar center

    // Tab colors
    tabActive: "#3d4e5f",
    tabInactive: "#30445a",
    tabPanel: "#3d4e5f",
    tabSubPanelPrimary: "#edd9ab",      // light tan
    tabSubPanelSecondary: "#edd9ab",    // light brown

    // Ability Row colors
    uiAbilityRowPositive: "#293a20",
    uiAbilityRowNegative: "#4c2015",
    uiAbilityRowBuy: "#3e3226",

    // UI Button colors
    // Sage
    uiBtnSageTop: "#4a624b",
    uiBtnSageMid: "#3f5740",
    uiBtnSageBottom: "#364e36",
    uiBtnSageBorder: "#f5f1e6",
    uiBtnSageText: "#f5f1e6",
    uiBtnSageFocus: "rgba(218, 190, 115, 0.65)",

    // Gold
    uiBtnGoldTop: "#f3d38a",
    uiBtnGoldMid: "#e6be6c",
    uiBtnGoldBottom: "#c79b4a",
    uiBtnGoldBorder: "#f5f1e6",
    uiBtnGoldText: "#3a2a14",
    uiBtnGoldFocus: "rgba(184, 147, 69, 0.7)",

    // Blue (steel / slate blue)
    uiBtnBlueTop: "#142a46",
    uiBtnBlueMid: "#0f2037",
    uiBtnBlueBottom: "#0b182a",
    uiBtnBlueBorder: "#f5f1e6",
    uiBtnBlueText: "#f5f1e6",
    uiBtnBlueFocus: "rgba(203, 183, 133, 0.7)",

    // Rust
    uiBtnRustTop: "#7a2b1d",
    uiBtnRustMid: "#612116",
    uiBtnRustBottom: "#4b170f",
    uiBtnRustBorder: "#f5f1e6",
    uiBtnRustText: "#f5f1e6",
    uiBtnRustFocus: "rgba(203, 183, 133, 0.7)",

    // Light Brown
    uiBtnBrownTop: "#a14e16",
    uiBtnBrownMid: "#80441d",
    uiBtnBrownBottom: "#5f2f14",
    uiBtnBrownBorder: "#f5f1e6",
    uiBtnBrownText: "#f5f1e6",
    uiBtnBrownFocus: "rgba(218, 190, 115, 0.65)",

    // Parchment

    // Pointed (Blue) Button colors (lighter steel / slate blue)
    pointBtnBlueTop: "#57748e",
    pointBtnBlueMid: "#507caf",
    pointBtnBlueBottom: "#476785",
} as const;
export type ColorKey = keyof typeof Colors;

export enum LoginAuthType {
    Email,
    MicroSoft,
    Google,
};

export enum RpgItemType {
    Item,
    Coin,
    Armor,
    Weapon,
    Container,
    Service,
    Ammo,
    Gem,
    Jewel,
    QuestItem,
};

export enum RpgProficiency {
    None,
    Proficient,
    Expert,
};
